import styled, {css} from "styled-components";

/* Media Query Breakpoints */

export const breakpoint = {
    laptop: `(max-width: 1100px)`,
    tablet: `(max-width: 800px)`,
    phone: `(max-width: 600px)`
}

export const accentColor = "rgb(42, 122, 88)";

/* Variable Font Styles */

export const bodyTextRegular = css`
    font-weight: 400;
    font-family: "Zen Maru Gothic", sans-serif;
`;

export const bodyTextBold = css`
    font-family: "Zen Maru Gothic", sans-serif;
    font-weight: 700;

`;

export const headingText = css`
    font-family: "Tenor Sans", sans-serif;
`;

export const linkActionColor = "#7b958a";
export const bodyTextAccentColor = "#C9B77D";

export const PageContainer = styled.div`
    width: 100%;
    position: relative;

    
    &:before {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 200px;
        content: "";
        background: linear-gradient(to bottom, rgba(200,200,200, 0.8), rgba(255,255,255,1));
        z-index: -10000;
    }

    &:after {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 400px;
        content: "";
        background: linear-gradient(to top, rgba(200,200,200, 0.8), rgba(255,255,255,1));
        z-index: -100;
    }


`;

export const SectionHeader = styled.div`

    // font-family: "Lora", serif;
    ${headingText}
    font-weight: 400;
    font-style: normal;
    text-transform: uppercase;

    width: fit-content;
    margin: 20px 20px 20px -50px;
    padding: 10px;
    padding-left: 150px;
    padding-right: 40px;
    transform: skew(-10deg);
    border: 1px solid #FFFFFF;
    border-radius: 25px;
    // background-color: rgba(247, 189, 69, 0.5);
    background-color: rgb(123, 149, 138);
    color: #ffffff;
    box-shadow: 4px 2px 4px #CECECE;

    & h2 {
        font-weight: 500;
        transform: skew(10deg);
        font-size: 20pt;
    }

    @media ${breakpoint.phone} {

        & h2 {
            font-size: 16pt;
        }

    }


`;

export const Section = styled.section`
    margin: 0px;
    padding: 50px 100px;

    ${bodyTextRegular}

    & p {
        font-size: 16pt;
        line-height: 30pt;
        font-weight: 400;
        padding: 20px;
        background-color: rgba(255,255,255, 0.8);
        width: 80%;
        border-radius: 10px;
    }

    & ul {
        font-size: 14pt;
        line-height: 24pt;
        font-weight: 400;
        padding: 20px;
        background-color: rgba(255,255,255, 0.8);
    }

    & li {
        list-style-type: square;
        margin-left: 40px;
    }

    & b {
        ${bodyTextBold}
    }


    @media ${breakpoint.laptop} {

        padding: 40px 60px;

        & p {
            padding: 20px 0px;
        }
    }

    @media ${breakpoint.tablet} {

        padding: 20px 40px;

        & p {
            width: 100%;
            padding: 20px 0px;
        }
    }

    @media ${breakpoint.phone} {

        & p {
            font-size: 14pt;
            line-height: 22pt;
        
        }

    }


`;

export const AccentedText = styled.span`
    display: inline;
    ${bodyTextBold}
    background-color: ${bodyTextAccentColor}33;
    padding: 2px 3px;
    border-radius: 5px;
`;

export const TwoColumnSection = styled(Section)`
    display: flex;
    flex-direction: row;
    align-items: center;

    & p {
        padding-top: 0px;
        margin-top: 0px;
        flex: 1 0 40%;
        width: 40%;
    }

    @media ${breakpoint.laptop} {
        flex-direction: column;

        & p {
            width: 100%;
            flex: unset;
            margin-top: 40px;
        }
    }

`;

export const ColumnImageContainer = styled.div`
    flex: 1 0 60%;
    width: 60%;
    padding-left: 40px;

    & img {
        width: 100%;
        border-radius: 10px;
        box-shadow: 3px 3px 8px #c0c0c0;
        border: 1px solid #ffffff;
    }

    &.no-shadow img {
        border: none;
        box-shadow: none;
    }

    &.position-left {
        padding-left: 0px;
        padding-right: 0px;
    }

    @media ${breakpoint.laptop} {

        width: 80%;
        flex: unset;
        padding: 0px;
        margin-top: 40px;
    }

    @media ${breakpoint.phone} {

        width: 100%;
        flex: unset;
        padding: 0px;
        margin-top: 20px;
    }

`;

export const IntroQuestionAside = styled.aside`
    ${bodyTextRegular}
    font-size: 24pt;
    line-height: 40pt;
    width: fit-content;
    text-align: left;
    margin: 0px auto 50px 100px;
    padding: 20px;
    padding-right: 100px;
    border-radius: 10px;
    background: rgba(255,255,255,0.9);
    position: relative;
    color: ${accentColor};


    & b {
        ${bodyTextBold}
    }

    @media ${breakpoint.tablet} {
        font-size: 18pt;
        line-height: 32pt;
        padding: 40px;

        margin-left: 0px;

    }

`;

export const CreativeTeamAndSponsorsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;

    @media ${breakpoint.laptop} {
        flex-direction: column;
    }

`;

export const SponsorsAside = styled.aside`
    flex: 1;
    // background-color: #f9f9f9;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    margin-left: 100px;
    max-width: 600px;
    align-self: flex-start;
    // box-shadow: 2px 2px 5px #f0f0f0;
    position: relative;

    & p#pre-label {
        position: relative;
        width: 80%;
        max-width: 600px;
        ${bodyTextBold}
        line-height: 24pt;
        margin: 0px;
        margin-bottom: 20px;
        padding: 10px;
        width: fit-content;
        // background-color: rgba(123, 149, 138, 0.2);
        // box-shadow: 2px 2px 3px #c0c0c0;
    
    }

    @media ${breakpoint.laptop} {
        margin-left: unset;
        margin-top: 100px;
        max-width: unset;
    }

    @media ${breakpoint.phone} {

        padding: 0px;

    }

`;


export const SponsorsGrid = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    &:hover div:not(:hover) {
        opacity: 0.4;
    }
`;

/*
The following rules were part of SponsorGridItem 
below when there was an odd number of icons 
to display

    &:last-of-type {
        width: 60%;
        flex: 1;
    }

    &:last-of-type img {
        max-width: 200px;
    }

*/

export const SponsorGridItem = styled.div`
    flex: 1 0 50%;
    width: 50%;
    min-width: 200px;
    padding: 0px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;


    & img {
        width: 80%;
        max-width: 150px;
        opacity: 1;
        margin: 20px;
    }


    & img.full-size {
        width: 100%;
        max-width: 200px;
        margin: 0px;
    }

    & img:hover {
        opacity: 1;
    }

    & a:link {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }


`;

export const GenericImage = styled.img`
    display: block;
    margin: 50px auto;
    width: 90%;
    max-width: 1200px;

    border-radius: 10px;
    box-shadow: 3px 3px 8px #c0c0c0;
    border: 1px solid #ffffff;

    @media ${breakpoint.laptop} {
        width: 80%;
        max-width: unset;

    }

`;
